import React from "react";
import NavbarComponent from "./NavbarComponent";
import SidebarAdmin from "./SidebarAdmin";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";
const Header = () => {
  const sampleLocation = useLocation();
  return (
    <>
      <NavbarComponent />
      {sampleLocation.pathname.includes("/admin") ? (
        <SidebarAdmin />
      ) : (
        <Sidebar />
      )}
    </>
  );
};

export default Header;
